export * from "map-obj";
export { default } from "map-obj";
